import React, { useState } from "react";

const FormInputPassword = (
  { field, 
    value, 
    handleChange, 
    error = null ,
  }
) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div  className={field.fieldSize || "col-12"} >
      {field.label !== null ? (
        <label className="form-label text-muted">
          {field.label}{" "}
          {field.required && <span className="text-danger small">*</span>}
        </label>
      ) : (
        <label className="mt-sm-4"></label>
      )}

      <div className="position-relative">
        <input
          type={showPassword ? "text" : "password"}
          className={`form-control form-control-md pe-5 ${error ? "border-danger" : ""}`}
          name={field.name}
          value={value}
          onChange={handleChange}
          placeholder={field.placeholder || ""}
          required={field.required || false}
          disabled={field.disabled || false}
        />

        <button
          type="button"
          className="btn btn-link position-absolute end-0 top-50 translate-middle-y me-2 p-0 text-muted"
          onClick={() => setShowPassword(!showPassword)}
          tabIndex={-1}
        >
          {showPassword ? (
            <i className="bi bi-eye"></i>
          ) : (
            <i className="bi bi-eye-slash"></i>
          )}
        </button>
      </div>

      {error && <span className="text-danger">{error}</span>}
    </div>
  );
};

export default FormInputPassword;
